import { useMemo } from 'react';
import { useAsyncFn } from 'react-use';

import useStateWhileMounted from 'hooks/useStateWhileMounted.hook';

const useAsyncFnFix = (fn, deps = []) => {
  const [loading, setLoading] = useStateWhileMounted(false);

  const wrapper = async (...args) => {
    try {
      setLoading(true);
      return await fn(...args);
    } finally {
      setLoading(false);
    }
  };

  // eslint-disable-next-line react-hooks/exhaustive-deps
  const [{ error, value }, handle] = useAsyncFn(wrapper, [fn, setLoading, ...deps]);

  return useMemo(() => [{ loading, error, value }, handle], [loading, error, value, handle]);
};

export default useAsyncFnFix;
